import type { DuplicatesViewState, ReduxAction } from '@repo/utils/types';
import AppState from '../app-state';
import { selectDuplicate } from '../data/duplicates';

const initialDuplicatesViewState = {
  selectedDuplicateID: null,
};

export const selectDuplicatesView = (state: AppState) => ({
  ...state.ui.duplicatesView,
  selectedDuplicate: selectSelectedDuplicate(state),
});

export const selectSelectedDuplicate = (state: AppState) => {
  const id = state.ui.duplicatesView.selectedDuplicateID;

  if (!id) {
    return null;
  }

  return selectDuplicate(id)(state);
};

export const selectActiveDuplicatesView = (state: AppState) => {
  if (state.ui.location?.pathname != '/people/duplicates') {
    return null;
  }

  const duplicatesView = selectDuplicatesView(state);
  const selectedDuplicate = selectSelectedDuplicate(state);

  return {
    ...duplicatesView,
    selectedDuplicate,
  };
};

export function duplicatesViewReducer(
  state: DuplicatesViewState = initialDuplicatesViewState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SET_SELECTED_DUPLICATE':
      return {
        ...state,
        selectedDuplicateID: payload.id,
      };

    default:
      return state;
  }
}
